<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii">To my husband, aka Hot Cop.<br/>It’s been a wonderful, crazy, divine seven years.<br/>Or has it been eight? I don’t remember. I only know<br/>that however much time we’ve had, it’s not enough.</a></p><a id="page_vii">
</a><p class="noindent"><a id="page_vii"></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e61551f6